import React from "react";
import { FaTimes } from "react-icons/fa";

function ImagePreviewModal({ src, onClose }) {
  if (!src) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/85 p-4 backdrop-blur-sm"
      onClick={onClose}
    >
      <button
        type="button"
        onClick={onClose}
        className="absolute right-4 top-4 inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-white/10 text-white transition hover:bg-white/20"
        aria-label="Fermer"
      >
        <FaTimes />
      </button>

      <img
        src={src}
        alt="Aperçu podium"
        className="max-h-full max-w-full rounded-2xl object-contain shadow-2xl"
        onClick={(event) => event.stopPropagation()}
      />
    </div>
  );
}

export default ImagePreviewModal;